import React from "react";

import HeroSection from "../components/Gallery/HeroSection";
import OurPhilosophy from "../components/Gallery/OurPhilosophy";
import ResidentialCare from "../components/Gallery/ResidentialCare";
import SupportedLiving from "../components/Gallery/SupportedLiving";
import DailyLife from "../components/Gallery/DailyLife";

const LifeAtRoselea = () => {
  return (
    <>
      <HeroSection />
      <OurPhilosophy />
      <ResidentialCare />
      <SupportedLiving />
      <DailyLife />
    </>
  );
};
export default LifeAtRoselea;
